import createCache from '@emotion/cache';
var cache;
export default function createEmotionCache() {
    // Ensure that the cache referenced in bootstrap and Application are the same
    if (cache) {
        return cache;
    }
    cache = createCache({ key: 'css' });
    return cache;
}
